export default "__VITE_PUBLIC_ASSET__cfb7e9b8__"